export const setLoader=(state,payload)=>{
		 state.loader=payload;
	}